<template>
  <div>
    <div class="edit-interests-btn" @click="launchEditEventInterestsModal">
      Edit interests
    </div>
  </div>
</template>

<script>
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";
import EditEventInterestsModal from "@/components/homebase/modals/EditEventInterestsModal";

export default {
  name: "edit-event-interests-button",
  props: ["topics", "showSubtitle"],
  mixins: [HomebaseMixpanelMixin],
  methods: {
    launchEditEventInterestsModal() {
      this.trackEventsEditInterestsClick();
      this.$modal.show(
        EditEventInterestsModal,
        {
          // add props here
          topics: this.topics,
          showSubtitle: this.showSubtitle
        },
        {
          adaptive: true,
          scrollable: true,
          width: 900,
          height: "auto",
        },
        {
          interestsSaved: () => {
            this.handleInterestsSaved();
          },
        }
      );
    },

    handleInterestsSaved() {
      this.$emit("interestsSaved");
      this.$parent.$emit("interestsSaved");
    },
  },
};
</script>

<style scoped>
.edit-interests-btn {
  font-family: artifaktElementBold;
  font-size: 16px;
  color: var(--secondary-color);
  text-decoration: underline;
}
.edit-interests-btn:hover {
  cursor: pointer;
  color: var(--secondary-color);
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/buttons/EditEventInterestsButton.vue